import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function reportReferencesRoutes($stateProvider: StateProvider) {
    let reportReferencesModule: {default: any;};

    if (window.portaroConfiguration.isSutorSutinLayout) {
        $stateProvider
            .state({
                name: 'reports',
                url: '/reports',
                component: KpSvelteComponentWrapperComponent.componentName,
                resolve: {
                    component: () => reportReferencesModule.default
                },
                lazyLoad: async () => {
                    reportReferencesModule = await import(/* webpackChunkName: "reportReferencesPage" */ './ReportReferencesPage.svelte');
                    return null;
                }
            });
    }
}